import { createAsyncAction } from 'typesafe-actions'
import { ReadUserWalletsRequestDto, ReadUserWalletsResponseDto } from '@sparling/financial-common'

export const {
  request: getUserWalletsRequest,
  success: getUserWalletsSuccess,
  failure: getUserWalletsFailure,
} = createAsyncAction('GET_USER_WALLETS_REQUEST', 'GET_USER_WALLETS_SUCCESS', 'GET_USER_WALLETS_FAILURE')<
  ReadUserWalletsRequestDto,
  ReadUserWalletsResponseDto,
  Error
>()
